<template>
  <div class="pages-schoolMine">
    <div class="top-line">
      <div class="small-button" @click="toBack()">返回</div>
      <span class="title">我的主页</span>
    </div>
    <div class="school-info">
      <img class="school-icon" src="../../../images/schoolIcon.png" alt="" />
      <div class="school-name">{{ nick_name }}</div>
      <div class="school-des">
        <div class="school-line">
          <div class="school-line-title">手机号</div>
          <div class="school-line-content">
            {{ hidePhone(user_name) }}
            <span class="school-edit-phone" @click="toEditPhone"
              >更换手机号</span
            >
          </div>
        </div>
        <div class="school-line">
          <div class="school-line-title" style="padding-top: 26px">
            上传空间
          </div>
          <div class="school-line-content" style="padding-top: 26px">
            <div class="school-used-num">
              {{ useredFileSize }} GB
              <span class="school-used-num-text">已用</span>
            </div>
            <div class="school-used-box">
              <div
                class="school-used"
                :style="{ width: (useredFileSize / 10) * 286 + 'px' }"
              ></div>
            </div>
            <div class="school-used-des">
              共 10.0 GB，剩余 {{ (10 - useredFileSize).toFixed(1) }} GB
            </div>
          </div>
        </div>
      </div>
      <div class="school-btn" @click="toEditPassword">修改密码</div>
    </div>

    <div v-if="editPhone" class="mask">
      <div class="edit-info">
        <div class="edit-close" @click="closeEditPhone"></div>
        <div class="edit-title">更换手机号</div>
        <div class="edit-line">
          <div class="edit-line-title" style="width: 129px">
            {{ editPhoneStep == 1 ? '原手机号：' : '新手机号：' }}
          </div>
          <el-input
            v-model="phone"
            :placeholder="
              editPhoneStep == 1 ? '请输入原手机号' : '请输入新手机号'
            "
            style="width: 224px"
          ></el-input>
          <div v-if="!sendSms" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms" class="get-code">{{ smsTimes }}s</div>
        </div>
        <div class="edit-line">
          <div class="edit-line-title" style="width: 129px">验证码：</div>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 224px"
          ></el-input>
        </div>
        <div
          @click="next"
          :class="{ submit: true, 'phone-next-no': !phone || !code }"
        >
          {{ editPhoneStep == 1 ? '下一步' : '提交' }}
        </div>
      </div>
    </div>
    <div v-if="editPhoneSuccess" class="mask">
      <div class="edit-phone-success">
        <div class="edit-close" @click="closeEditPhoneSuccess"></div>
        <img
          class="edit-phone-success-img"
          src="../../../images/editSuccess.png"
          alt=""
        />
        <div class="edit-phone-success-des">手机号修改成功，请重新登录。</div>
      </div>
    </div>
    <div v-if="editPassword" class="mask">
      <div class="edit-info">
        <div class="edit-close" @click="closeEditPassword"></div>
        <div class="edit-title">修改密码</div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">原密码：</div>
          <el-input
            v-model="password"
            placeholder="请输入原密码"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">
            <!-- {{ editPhoneStep == 1 ? '原手机号：' : '新手机号：' }} -->
            手机号：
          </div>
          <el-input
            v-model="phone"
            placeholder="请输入手机号"
            style="width: 224px"
          ></el-input>
          <div v-if="!sendSms" class="get-code" @click="toSendSms">
            {{ sendFirst ? '获取验证码' : '重新获取' }}
          </div>
          <div v-if="sendSms" class="get-code">{{ smsTimes }}s</div>
        </div>
        <div v-if="editPasswordStep == 1" class="edit-line">
          <div class="edit-line-title" style="width: 129px">验证码：</div>
          <el-input
            v-model="code"
            placeholder="请输入验证码"
            style="width: 224px"
          ></el-input>
        </div>
        <div v-if="editPasswordStep == 2" class="edit-line password-line">
          <div class="edit-line-title">新密码：</div>
          <el-input
            v-model="passwordNew"
            placeholder="请输入新密码"
            style="width: 224px"
            @blur="onPasswordBlur"
            show-password
          ></el-input>
          <div class="password-tips">
            密码必须包含字母、数字和英文符号，长度至少8位，区分大小写
          </div>
        </div>
        <div v-if="editPasswordStep == 2" class="edit-line">
          <div class="edit-line-title">确认密码：</div>
          <el-input
            v-model="passwordNewAgain"
            placeholder="请再次输入新密码"
            style="width: 224px"
            show-password
          ></el-input>
        </div>
        <div
          @click="nextPassword"
          :class="{
            submit: true,
            'phone-next-no':
              (editPasswordStep == 1 && (!phone || !code || !password)) ||
              (editPasswordStep == 2 && (!passwordNew || !passwordNewAgain)),
          }"
        >
          {{ editPasswordStep == 1 ? '下一步' : '提交' }}
        </div>
      </div>
    </div>
    <div v-if="editPasswordSuccess" class="mask">
      <div class="edit-phone-success">
        <div class="edit-close" @click="closeEditPasswordSuccess"></div>
        <img
          class="edit-phone-success-img"
          src="../../../images/editSuccess.png"
          alt=""
        />
        <div class="edit-phone-success-des">密码修改成功，请重新登录。</div>
      </div>
    </div>

    <!-- <div class="content">
      <div class="editInfo-line">
        <div class="editInfo-line-title">修改名称:</div>
        <el-input
          v-model="nick_name"
          placeholder="请输入内容"
          style="width: 306px"
        ></el-input>
      </div>
      <div class="editInfo-line">
        <div class="editInfo-line-title">帐号:</div>
        <el-input
          v-model="user_name"
          placeholder="请输入内容"
          style="width: 306px"
          disabled
        ></el-input>
        <div class="tips">*系统生成，不可修改</div>
      </div>
      <div class="editInfo-line" style="margin-top: 27px">
        <div class="editInfo-line-title">修改密码:</div>
        <el-input
          v-model="password"
          placeholder="请输入内容"
          style="width: 306px"
        ></el-input>
      </div>
      <div class="submit" @click="submit">提交修改</div>
    </div> -->
  </div>
</template>

<script>
import {
  editSchool,
  userSave,
  send_sms2,
  sms_auth,
  update_self,
  update_phone,
  school_file_size,
  check_phone_status,
} from '@/api/api.js'

export default {
  name: 'EditInfo',
  data: () => ({
    userInfo: {},
    nick_name: '',
    user_name: '',
    // password: '',
    useredFileSize: 0,

    editPhone: false, // 编辑电话
    editPhoneStep: 1, // 1原手机号 2新手机号
    smsTimes: 0,
    phone: '',
    code: '',
    sendSms: false,
    sendFirst: true,
    editPhoneSuccess: false, // 编辑电话成功

    editPassword: false, // 编辑密码
    editPasswordStep: 1,
    password: '',
    passwordNew: '',
    passwordNewAgain: '',
    editPasswordSuccess: false, // 编辑密码成功

    sendInterval: null,
  }),
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem('yey-user'))
    this.userInfo = userInfo
    this.nick_name = userInfo.nick_name
    this.user_name = userInfo.user_name

    // 测试学校1   CSXX-120239
    // 测试学校2   CSXX-2202310
    school_file_size().then((res) => {
      console.log('school_file_size', res)
      let fileSize = res.data.data
      this.useredFileSize = (fileSize / 1024 / 1024 / 1024).toFixed(1)
    })
  },
  methods: {
    hidePhone(phone) {
      if (phone.length !== 11) {
        return phone
      }
      let newPhone = phone.substr(0, 3) + '******' + phone.substr(8)
      return newPhone
    },
    toBack() {
      this.$router.back()
    },
    submit() {
      if (!this.nick_name) {
        this.$message.error('请先填写名称!')
        return
      }
      let data = {
        role: 'school',
        id: this.userInfo.id,
        nick_name: this.nick_name,
      }
      if (this.password) {
        data.password = this.password
      }
      console.log('data', data)
      //   editSchool
      userSave(data).then((res) => {
        console.log('userSave', res)
        let userInfo = JSON.parse(localStorage.getItem('yey-user'))
        userInfo.nick_name = this.nick_name
        localStorage.setItem('yey-user', JSON.stringify(userInfo))
        this.$message({
          type: 'success',
          message: '修改成功!',
        })
        setTimeout(() => {
          this.$route.params.edit = true
          this.$router.back()
        }, 500)
      })
    },

    toEditPhone() {
      this.editPhone = true
    },
    closeEditPhone() {
      this.editPhone = false
      this.sendSms = false
      this.sendFirst = true
      this.editPhoneStep = 1
      clearInterval(this.sendInterval)
    },
    async toSendSms() {
      console.log('phone', this.phone)
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (this.sendSms) {
        return
      }

      if (this.editPhoneStep == 2) {
        let phoneStatus = 0 // 0未注册(审核不通过) 1注册了未审核 2审核成功
        let phoneRes = await check_phone_status({ phone: this.phone })
        console.log('phoneRes', phoneRes)
        if (phoneRes.data.data == '手机号已注册，已审核') {
          phoneStatus = 2
          this.$message.error('手机号已被注册')
          return
        }
        if (phoneRes.data.data == '手机号已注册，待审核') {
          phoneStatus = 1
          this.$message.error('手机号已被注册，等待审核')
          return
        }
      }

      let res = null
      //   if (this.editPhoneStep == 1) {
      //     res = await send_sms2({ phone: this.phone })
      //   } else {
      //     res = await send_sms({ phone: this.phone })
      //   }
      res = await send_sms2({
        phone: this.phone,
        new_phone: this.editPhoneStep == 2 ? 1 : 0,
      })
      console.log('send_sms', res)
      if (res.data.code == -1) {
        if (res.data.msg == '触发分钟级流控Permits:1') {
          this.$message.error('验证码获取频繁，请于1分钟后再次尝试')
          return
        }
        if (res.data.msg == '触发小时级流控Permits:5') {
          this.$message.error('验证码获取频繁，请于1小时后再次尝试')
          return
        }
        if (res.data.msg == '触发天级流控Permits:10') {
          this.$message.error('验证码获取频繁，请于1天后再次尝试')
          return
        }
        this.$message.error(res.data.msg)
        return
      }
      this.sendSms = true
      this.sendFirst = false
      this.smsTimes = 59
      clearInterval(this.sendInterval)
      this.sendInterval = setInterval(() => {
        this.smsTimes = this.smsTimes - 1
        if (this.smsTimes < 1) {
          this.sendSms = false
          clearInterval(this.sendInterval)
        }
      }, 1000)
    },
    async next() {
        // if (this.editPhoneStep == 1) {
        //   this.editPhoneStep = 2
        //   this.phone = ''
        //   this.code = ''
        //   return
        // } else {
        //   this.editPhone = false
        //   this.editPhoneSuccess = true
        // }
        // return
      if (!this.phone) {
        this.$message.error('请先填写手机号')
        return
      }
      if (!this.code) {
        this.$message.error('请先填写验证码')
        return
      }
      if (this.editPhoneStep == 1) {
        let res = await sms_auth({ phone: this.phone, v_code: this.code })
        console.log('sms_auth', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.phone = ''
        this.code = ''
        this.editPhoneStep = 2
        this.sendFirst = true
        this.sendSms = false
        clearInterval(this.sendInterval)
      } else {
        let res = await update_phone({ phone: this.phone, v_code: this.code })
        console.log('update_phone', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.editPhone = false
        this.editPhoneSuccess = true
        setTimeout(() => {
          this.closeEditPhoneSuccess()
        }, 2000)
      }
    },
    closeEditPhoneSuccess() {
      localStorage.removeItem('yey-user')
      localStorage.removeItem('yey-token')
      this.$router.push('/login')
      //   this.editPhoneSuccess = false
    },

    toEditPassword() {
      this.editPassword = true
      this.password = ''
    },
    closeEditPassword() {
      this.editPassword = false
      this.editPasswordStep = 1
    },
    async nextPassword() {
        // if (this.editPasswordStep == 1) {
        //   this.editPasswordStep = 2
        // } else {
        //   this.editPassword = false
        //   this.editPasswordSuccess = true
        // }
        // return

      if (this.editPasswordStep == 1) {
        if (!this.password) {
          this.$message.error('请先填写原密码')
          return
        }
        let password = localStorage.getItem('yey-password')
        if (this.password !== password) {
          this.$message.error('原密码错误')
          return
        }
        if (!this.phone) {
          this.$message.error('请先填写手机号')
          return
        }
        if (!this.code) {
          this.$message.error('请先填写验证码')
          return
        }
        let res = await sms_auth({ phone: this.phone, v_code: this.code })
        console.log('sms_auth', res)
        if (res.data.code == -1) {
          this.$message.error(res.data.msg)
          return
        }
        this.phone = ''
        this.code = ''
        this.editPasswordStep = 2
      } else {
        let password = localStorage.getItem('yey-password')
        if (this.passwordNew == password) {
          this.$message.error('新密码不能与原密码相同')
          return
        }
        if (!this.passwordNew || !this.passwordNewAgain) {
          this.$message.error('请先填写密码')
          return
        }
        if (this.passwordNew !== this.passwordNewAgain) {
          this.$message.error('两次密码输入不一致')
          return
        }
        if (this.passwordNew.length < 8) {
          this.$message.error('密码最短为8位')
          return
        }
        let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
        if(!reg.test(this.passwordNew)) {
          this.$message.error('密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！')
          return
        }
        update_self({ password: this.passwordNew }).then((res) => {
          console.log('update_self', res)
          if (res.data.code == -1) {
            this.$message.error(res.data.msg)
            return
          }
          this.editPassword = false
          this.editPasswordSuccess = true
          localStorage.setItem('yey-password', this.passwordNew)
          setTimeout(() => {
            this.closeEditPasswordSuccess()
          }, 2000)
        })
      }
    },
    closeEditPasswordSuccess() {
      //   this.editPasswordSuccess = false
      localStorage.removeItem('yey-user')
      localStorage.removeItem('yey-token')
      this.$router.push('/login')
    },
    onPasswordBlur() {
      let reg = /(?=.*[a-zA-z])(?=.*[0-9])(?=.*[!@#$%^&*,.;:])/g
      if(this.passwordNew.length == 0){
        return
      }
      if(!reg.test(this.passwordNew)) {
        this.$message.error('密码需包含字母、数字和特殊符号（!@#$%^&*,.;:）！')
      }
    }
  },
}
</script>

<style lang="less" scoped>
.pages-schoolMine {
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
    margin-left: 140px;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }

  .school-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1470px;
    height: 832px;
    margin: 9px auto;
    padding-top: 115px;
    background: #ffffff;
    border-radius: 0px 0px 10px 10px;
    border: 1px solid #e9f7fe;
    box-sizing: border-box;
    .school-icon {
      width: 138px;
      height: 137px;
    }
    .school-name {
      margin-top: 10px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
    }
    .school-des {
      margin-top: 48px;
      border-radius: 10px;
      border: 1px solid #add1f4;
      .school-line {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #add1f4;
        &:last-child {
          border-bottom: none;
        }
        .school-line-title {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 190px;
          height: 96px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          border-right: 1px solid #add1f4;
          box-sizing: border-box;
        }
        .school-line-content {
          position: relative;
          display: flex;
          align-items: center;
          width: 583px;
          height: 96px;
          padding-left: 50px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          box-sizing: border-box;
          .school-edit-phone {
            padding-left: 10px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #27b2fe;
            text-decoration: underline;
            cursor: pointer;
          }
          .school-used-num {
            position: absolute;
            top: 10px;
            left: 50px;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 44px;
            .school-used-num-text {
              margin-left: 5px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #808080;
              line-height: 44px;
            }
          }
          .school-used-box {
            width: 286px;
            height: 20px;
            background: #e6fae6;
            border-radius: 4px;
            .school-used {
              width: 99px;
              height: 20px;
              background: #53c851;
              border-radius: 4px;
            }
          }
          .school-used-des {
            margin-left: 26px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #808080;
          }
        }
      }
    }
    .school-btn {
      width: 121px;
      height: 40px;
      margin-top: 80px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      background: #27b2fe;
      border-radius: 4px;
      cursor: pointer;
    }
  }

  // .content {
  //   width: calc(100vw - 280px);
  //   height: calc(100vh - 220px);
  //   margin-left: 140px;
  //   padding-left: 80px;
  //   padding-top: 85px;
  //   background-color: #fff;
  //   box-sizing: border-box;
  // }
  // .editInfo-line {
  //   position: relative;
  //   display: flex;
  //   align-items: center;
  //   height: 70px;
  //   .editInfo-line-title {
  //     width: 110px;
  //     margin-right: 12px;
  //     font-size: 18px;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #4d4d4d;
  //     line-height: 25px;
  //     text-align: right;
  //   }
  //   .tips {
  //     position: absolute;
  //     top: 63px;
  //     left: 122px;
  //     font-size: 14px;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #999999;
  //     line-height: 20px;
  //   }
  // }
  // .submit {
  //   width: 140px;
  //   height: 40px;
  //   margin: 25px 143px;
  //   font-size: 18px;
  //   font-family: PingFangSC-Medium, PingFang SC;
  //   font-weight: 500;
  //   color: #ffffff;
  //   line-height: 40px;
  //   text-align: center;
  //   background: #27b2fe;
  //   border-radius: 4px;
  //   cursor: pointer;
  // }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(#000, 0.7);
  }
  .edit-close {
    position: absolute;
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(45deg);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 10px;
      width: 13px;
      height: 2px;
      background-color: #909399;
      border-radius: 2px;
      transform: rotate(-45deg);
    }
  }
  .edit-info {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 526px;
    // height: 287px;
    padding-bottom: 26px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .edit-title {
      padding: 16px 0 0 30px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 36px;
    }
    .edit-line {
      display: flex;
      align-items: center;
      padding: 10px 0;
      //   padding: 10px 0 10px 127px;
      .edit-line-title {
        width: 175px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
        text-align: right;
      }
      .edit-line-img {
        width: 54px;
        height: 54px;
        border-radius: 27px;
      }
      .edit-line-upload {
        position: relative;
        width: 56px;
        height: 22px;
        margin-top: 32px;
        margin-left: 2px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #27b2fe;
        line-height: 22px;
        text-align: center;
        border-radius: 20px;
        border: 1px solid #27b2fe;
        .upload-abs {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          margin: 0;
          opacity: 0;
        }
      }
      .get-code {
        width: 114px;
        height: 40px;
        margin-left: 10px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #00aeff;
        line-height: 40px;
        text-align: center;
        background: rgba(39, 178, 254, 0.1);
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .password-line{
      position: relative;
      margin-bottom: 50px;
      .password-tips{
        position: absolute;
        top: 60px;
        left: 178px;
        width: 300px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
      }
    }
    .submit {
      width: 140px;
      height: 42px;
      margin: 20px auto 0;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      background: #27b2fe;
      border-radius: 100px;
      cursor: pointer;
    }
    .phone-next-no {
      background: rgba(39, 178, 254, 0.2);
    }
  }

  .edit-phone-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 412px;
    height: 168px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .edit-phone-success-img {
      width: 54px;
      height: 54px;
    }
    .edit-phone-success-des {
      margin-top: 10px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
    }
  }
}
</style>
